<template>
    <div>
        <h4
            class="group-heading"
            @click="showMenu = !showMenu"
            v-if="sidebarLinkGroupFitlered && sidebarLinkGroupFitlered.length > 0"
        >
            <i
                v-if="sidebarLinkGroupFitlered.icon"
                :class="`fas menu-icon fa-${sidebarLinkGroupFitlered.icon}`"
            />
            {{ sidebarLinkGroup.title }}
            <i
                :class="[
                    { 'fas fa-chevron-down': !showMenu },
                    { 'fas fa-chevron-up': showMenu },
                    'chevron-icon',
                ]"
            />
        </h4>
        <div v-if="showMenu">
            <template v-for="sidebarLink of sidebarLinkGroupFitlered">
                <a
                    v-if="sidebarLink.forceReload"
                    :class="[
                        'block outline-none sidebar-item',
                        {
                            active:
                                $route.path.startsWith(sidebarLink.link) ||
                                $route.path === sidebarLink.link,
                        },
                    ]"
                    :key="sidebarLink.link"
                    :href="sidebarLink.link"
                    @click="scrollTopFirst"
                >
                    <i v-if="sidebarLink.icon" :class="`fas menu-icon fa-${sidebarLink.icon}`" />
                    {{ sidebarLink.title }}
                </a>
                <router-link
                    v-else
                    :class="[
                        'block outline-none sidebar-item',
                        {
                            active:
                                $route.path.startsWith(sidebarLink.link) ||
                                $route.path === sidebarLink.link,
                        },
                    ]"
                    :key="sidebarLink.link"
                    :to="sidebarLink.link"
                    @click="scrollTopFirst"
                >
                    <i v-if="sidebarLink.icon" :class="`fas menu-icon fa-${sidebarLink.icon}`" />
                    {{ sidebarLink.title }}</router-link
                >
            </template>
        </div>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex"
import { checkHasPermission } from "../../store/permission"

export default {
    props: {
        sidebarLinkGroup: { type: Object, default: () => ({}) },
    },
    data() {
        return { showMenu: false }
    },
    computed: {
        ...mapState("auth", ["user"]),

        sidebarLinkGroupFitlered() {
            // filter by permissions
            const filteredLinks = this.sidebarLinkGroup.data.filter(
                (sidebarLink) => {
                    const result = checkHasPermission({
                        isAdmin: this.user.isAdmin,
                        permissionId: sidebarLink.permission,
                        userPermissionIds: this.user.permissionIds,
                    })
                    return result
                }
                // false
            )
            // console.log("filtered lnks", filteredLinks)
            return filteredLinks
        },
    },
    mounted() {
        this.checkAndOpenMenu()
    },
    watch: {
        $route() {
            this.checkAndOpenMenu()
        },
    },
    methods: {
        checkAndOpenMenu() {
            for (let sidebarLink of this.sidebarLinkGroup.data) {
                if (this.$route.path.startsWith(sidebarLink.link) || this.$route.path === sidebarLink.link) {
                    this.showMenu = true
                    return
                }
            }
        },
        scrollTopFirst() {
            window.scrollTo({ top: 0, behavior: "smooth" })
        },
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";

.group-heading {
    text-transform: uppercase;
    padding: 10px 12px;
    margin-top: 8px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.05em;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    color: $gray400;
    border-radius: $radiusSm;
    transition: all $transitionFast;

    &:hover {
        color: $gray700;
        background: $gray50;
    }
}
.sidebar-item {
    display: flex;
    align-items: center;
    gap: 8px;
    text-transform: none;
    border-radius: $radiusSm;
    margin-bottom: 2px;
    font-size: 13px;
    font-weight: 450;
    padding: 10px 12px;
    color: $gray600;
    transition: all $transitionFast;
    position: relative;

    &.active {
        font-weight: 600;
        background: $primaryColor;
        color: #fff;
        box-shadow: 0 2px 8px rgba(0, 94, 137, 0.25);

        .menu-icon {
            color: rgba(255, 255, 255, 0.9);
        }
    }

    &:hover:not(.active) {
        background: $gray100;
        color: $gray800;
        transform: translateX(2px);
    }
}
.menu-icon {
    font-size: 13px;
    width: 18px;
    text-align: center;
    color: $gray400;
    transition: color $transitionFast;
}
.chevron-icon {
    color: $gray400;
    font-size: 10px;
    transition: transform $transitionFast;
}
</style>
